import { useMutation, useQueryClient } from 'react-query'

import { useAuthedFetch } from '../auth/useAuthedFetch'
import withFetchCancel from '../libs/withFetchCancel'

const BACKEND_ENDPOINT = process.env.REACT_APP_BACKEND_ENDPOINT

export const useShippingReturnMutation = () => {
  const authedFetch = useAuthedFetch()
  const queryClient = useQueryClient()

  return useMutation(
    ({ shippingCode }) =>
      withFetchCancel(signal =>
        authedFetch(
          'POST',
          `${BACKEND_ENDPOINT}/rpc-return-shipping/${shippingCode}`,
          {
            signal,
            parseJSON: true,
            data: {
              metadata: {
                interchange_id: null,
                timestamp: null,
                correlation_id: null,
                source: null,
              },
              audit: {
                process_code: 'BROKER',
              },
            },
          },
        ),
      ),
    {
      onSuccess: response => {
        response.data = { shippingCode: response.data.shipping_code }
      },

      onSettled: () => queryClient.invalidateQueries('shippingsTracking'),
    },
  )
}

export const useShippingReturnDeliveredMutation = () => {
  const authedFetch = useAuthedFetch()
  const queryClient = useQueryClient()

  return useMutation(
    ({ shippingCode, phone, email }) =>
      withFetchCancel(signal =>
        authedFetch(
          'POST',
          `${BACKEND_ENDPOINT}/rpc-create-reverse-shipping/${shippingCode}`,
          {
            signal,
            parseJSON: true,
            data:
              email && phone
                ? {
                    metadata: {
                      interchange_id: null,
                      timestamp: null,
                      correlation_id: null,
                      source: null,
                    },
                    audit: {
                      process_code: 'BROKER',
                    },
                    sender_email_notify_address: email,
                    sender_phones: [phone],
                  }
                : email
                ? {
                    metadata: {
                      interchange_id: null,
                      timestamp: null,
                      correlation_id: null,
                      source: null,
                    },
                    audit: {
                      process_code: 'BROKER',
                    },
                    sender_email_notify_address: email,
                  }
                : phone
                ? {
                    metadata: {
                      interchange_id: null,
                      timestamp: null,
                      correlation_id: null,
                      source: null,
                    },
                    audit: {
                      process_code: 'BROKER',
                    },
                    sender_phones: [phone],
                  }
                : {
                    metadata: {
                      interchange_id: null,
                      timestamp: null,
                      correlation_id: null,
                      source: null,
                    },
                    audit: {
                      process_code: 'BROKER',
                    },
                  },
          },
        ),
      ),
    {
      onSuccess: response => {
        response.data = { shippingCode: response.data.shipping_code }
      },

      onSettled: () => queryClient.invalidateQueries('shippingsTracking'),
    },
  )
}
